import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=cfc4383e&scoped=true&"
import script from "./SectionMenu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SectionMenu.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=cfc4383e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc4383e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc4383e')) {
      api.createRecord('cfc4383e', component.options)
    } else {
      api.reload('cfc4383e', component.options)
    }
    module.hot.accept("./SectionMenu.vue?vue&type=template&id=cfc4383e&scoped=true&", function () {
      api.rerender('cfc4383e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/SectionMenu/SectionMenu.vue"
export default component.exports